<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex w-full items-center p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <img class="w-12" src="images/logo/dp_logo.png" alt="District Printing" />
            </div>
            <!-- Components -->
            <div class="ml-auto flex items-center">
                <notifications></notifications>
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User -->
        <div class="flex w-full flex-col items-center p-4">
            <div class="relative h-24 w-24 overflow-hidden rounded-full">
                @if (user.avatar) {
                    <img
                        class="h-full w-full object-cover"
                        [src]="user.avatar"
                        alt="User avatar"
                    />
                }
                @if (!user.avatar) {
                    <mat-icon
                        class="icon-size-24"
                        [svgIcon]="'heroicons_solid:user-circle'"
                    ></mat-icon>
                }
            </div>
            <div class="mt-6 flex w-full flex-col items-center justify-center">
                <div
                    class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal"
                >
                    {{ user.name }}
                </div>
                <div
                    class="text-secondary mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-md font-medium leading-normal"
                >
                     {{ user.email }}
                </div>
            </div>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div
            class="mb-4 mt-2 flex h-16 flex-0 items-center justify-center pl-2 pr-6 opacity-50"
        >
            <img class="max-w-28" src="images/logo/dp_logo.png" alt="District Printing" />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col bg-gray-900">

    <!-- Drawer container -->
    <mat-drawer-container class="flex-auto"  [hasBackdrop]="false">

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col">
            <!-- Header -->
            <div
                class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 lg:pr-3 print:hidden"
            >
                <!-- Navigation toggle button -->
                <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
                <!-- Components -->
                <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
                    <!-- Add Order Button -->
                    <button mat-icon-button [routerLink]="['/orders/new']" [matTooltip]="'Add new order'">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    </button>
                    <!-- Add User Button -->
                    <button mat-icon-button (click)="openAddUserDrawer()" [matTooltip]="'Add new user'">
                        <mat-icon [svgIcon]="'heroicons_outline:user-plus'"></mat-icon>
                    </button>
                    <!-- <languages></languages> -->
                    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                  <!--   <search [appearance]="'bar'"></search>
                    <shortcuts></shortcuts> -->
                    <voice-calls></voice-calls>
                    <messages></messages>
                    <timeline-activities></timeline-activities>
                    <updates-required></updates-required>
                    <!-- <button
                        mat-icon-button
                        (click)="quickEmail.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:envelope'"></mat-icon>
                    </button> -->
                    <button
                        class="lg:hidden"
                        mat-icon-button
                        (click)="quickChat.toggle()"
                    >
                        <mat-icon
                            [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                        ></mat-icon>
                    </button>
                </div>
            </div>

            <!-- Content -->
            <div class="flex flex-auto flex-col px-0 py-0 md:px-3 md:py-3 lg:pl-6 lg:pr-[var(--quick-chat-rail-width)] lg:py-6">
                <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                     Otherwise, layout changes won't be registered and the view won't be updated! -->
                @if (true) {
                    <div class="flex flex-auto flex-col xl:px-0 xl:py-0">
                        <router-outlet></router-outlet>
                    </div>
                }
            </div>

            <!-- Footer -->
            <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
                <span class="font-medium text-secondary">District Printing &copy; {{currentYear}}</span>
            </div>-->
        </mat-drawer-content>

        <!-- Drawer for adding a new user -->
          
        <mat-drawer #addUserDrawer class="w-full md:w-160"  [mode]="'over'" [position]="'start'">
            <div class="flex flex-col h-full overflow-hidden">
                <div class="flex items-center justify-between flex-shrink-0 px-8 pt-8 pb-4">
                     <h2 class="text-2xl font-semibold">New Customer</h2>
                     <button mat-icon-button (click)="addUserDrawer.close()">
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                     </button>
                </div>
                <div class="flex-1 min-h-0 overflow-hidden">
                    @defer (on timer(1s)) {
                        <quick-add-user [customerMode]="true" (closeDrawer)="addUserDrawer.close()"></quick-add-user>
                    }
                </div>
            </div>
        </mat-drawer>
 
    </mat-drawer-container>

</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat"></quick-chat>
<!-- <quick-email #quickEmail="quickEmail"></quick-email> -->
